export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/analytics.worker.a2543fe8.worker.js");
}
